import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { MysqlService } from './../../../services/mysql.service';
import { BsModalService } from 'ngx-bootstrap';


@Component({
  selector: 'app-myob-tax-codes-grid',
  templateUrl: './myob-tax-codes-grid.component.html',
  styleUrls: ['./myob-tax-codes-grid.component.css']
})
export class MyobTaxCodesGridComponent implements OnInit {
  



  @Input() sent_data?: any; // not used

  // Grid Vars
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 25 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  


     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes.
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  initialPage: { pageSize: number; };
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  subjects_urgent: Object[];
  myob_account_codes: Object;
  myob_tax_codes: Object;

     constructor(
      private http: HttpClient, private _demoService: DemoService,
      private route: ActivatedRoute, public toastr: HotToastService,
       vcr: ViewContainerRef, private router: Router,
       public HttpClient:HttpClient,
       private fileUploader: FileUploaderService,
       private _mysqlService: MysqlService,
       private modalService: BsModalService,
       public datepipe: DatePipe,
       public gfunc: GlobalFunctionsService
    ) {
      
  
  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
  
      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
  
  
     }
  
     // check for changes. to load data.
     ngOnChanges(changes) {
      if (changes.item_id) {
        // deal with asynchronous Observable result
        this.item_id = changes.item_id.currentValue;
        // this.getJob(this.job_id);
      }
    }
  
    ngOnInit() {

      // load the SOP Brands/Clients
      // this.mapJobTableLiveClients();
      
          // Load the data
                this.getMyobTaxCodes();
      
                // Grid Options
                this.toolbarOptions = ['ExcelExport', 'Search'];
                this.initialPage = { pageSize:5 };
                this.filterOptions = {
                   type: 'Menu'
                };
               // this.groupOptions = { columns: [''] }; // sets auto grouping for the grid
                this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
                this.dateFormat = 'dd/MM/yyyy hh:mm a';
                this.filter = { params: { format: this.dateFormat } };
               // this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };
            
            
            // end date filter options
                // End Grid Options
        }
      
      
      
        // :: Grid Functions
      
      
      // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
      clickHandler(args: ClickEventArgs): void {
        if (args.item.id === 'Click') {
      
        //  this.grid.showSpinner();
      
        //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
       //  console.log(args.data.items);
       
      
      
        let pdfdata;
        const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
        for (let i = 0; i < query.queries.length; i++) {
          if (query.queries[i].fn === 'onPage') {
            query.queries.splice(i, 1);       // remove page query to get all records
            break;
          }
        }
        const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
          pdfdata = e.result as object[];  // get all filtered records
          const exportProperties = {
            dataSource: pdfdata,
          };
          // console.log(pdfdata.results);
      
         // this.search_results = pdfdata.records; // need this if a grouping is set.
        /*   this.search_results = pdfdata;
          this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
          this.toastr.success( "Press Start To Process Que");  */
         // this.grid.pdfExport(exportProperties);
        }).catch((e) => true);
        }
      
       //  this.grid.hideSpinner();
      
      };
      
      
      toolbarClick(args: ClickEventArgs): void {
        if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
            this.grid.excelExport();
        }
      }
      rowDataBound(args: RowDataBoundEventArgs) {
        const job_status = 'job_status';
        if (args.data[job_status] === 'CLOSED') {
            args.row.className = 'strikethrough';
        }
      }
      
        // :: Grid Functions
      
      
      
        getMyobTaxCodes() {
          this._demoService.getMyobTaxCodes().subscribe(
             data => { this.myob_tax_codes = data;
              let res = data[0];
      
              // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
              // // console.log(this.arrCase);
              // this.Items = data['Items'] ;
              // this.sent_data = this.Items;
              this.sent_data = this.myob_tax_codes;
      
            },
             err => console.error(err),
             // () => console.log('done loading Trace Types')
           );
         }
      
      
         deleteMyobTaxCode(myob_tax_code_id) {
          if (confirm('Are you sure you want to delete this Tax code. It will impact all created invocies, billing items and cause system errors!! Only delete if you are realy sure!!!? ')) {
          this._demoService.deleteMyobTaxCode(myob_tax_code_id).subscribe(
             data => { 
             let res = data;
             this.toastr.success('removed');
             this.refreshGrid();
               },
             err => {
              console.error(err)
              this.toastr.error('error, did not remove');
            },
              () => {
              //  console.log('done loading SR');
                 }
                );
                }
        }
      
      
         refreshGrid(){ // refresh the databutton
          // this.loadList(this.doc_id);
          this.getMyobTaxCodes();
          this.grid.refresh();
        };
      
      
      
      }
      